import { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

const SwatchSelector = lazy(() =>
    import(/* webpackChunkname: "swatchSelectorMain "*/ './SwatchSelectorMain')
);

const PdpRespSwatchSelectorComponent = props => {
    const { onClick, item, user, relay, selectedSkuId, showSwatchDescriptionOnHover } = props;

    return (
        <Suspense fallback={''}>
            <SwatchSelector
                selectedSkuId={selectedSkuId}
                item={item}
                userIsTrade={user && !!user.isVerifiedTrade}
                transactions={null}
                onClick={onClick}
                relay={relay}
                pageLayout="PDP"
                showSwatchDescriptionOnHover={showSwatchDescriptionOnHover}
            />
        </Suspense>
    );
};

PdpRespSwatchSelectorComponent.propTypes = {
    relay: PropTypes.object.isRequired,
    onSwatchClick: PropTypes.func,
    selectedSkuId: PropTypes.string,
    onClick: PropTypes.func,
    showSwatchDescriptionOnHover: PropTypes.bool,

    // relay response data
    user: PropTypes.object,
    item: PropTypes.object.isRequired,
};
export const PdpRespSwatchSelector = createFragmentContainer(PdpRespSwatchSelectorComponent, {
    item: graphql`
        fragment PdpRespSwatchSelector_item on Item {
            ...SwatchSelector_item @arguments(shouldFetchBuyerInfo: true)
        }
    `,
    user: graphql`
        fragment PdpRespSwatchSelector_user on User {
            isVerifiedTrade
        }
    `,
});
